import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Row } from 'antd'
import PropTypes from 'prop-types'

import { HiddenInputs, TextArea } from '../../../core/components'
import { Button } from '../../../core/components/styled'

import { MENU_SCRAPING_TEMPLATE_PERMISSIONS } from '../../../common/constants'
import { useUserHasPermissions } from '../../../common/hooks'

import { scrapingTemplateCommentFormInitialValues } from './initial-values'

const ScrapingTemplateCommentForm = ({
  scrapingTemplate,
  closeModal,
  isSettingScrapingTemplateComment,
  onSubmit,
}) => {
  const hasTemplateAdminPermission = useUserHasPermissions(
    MENU_SCRAPING_TEMPLATE_PERMISSIONS.ADMIN,
  )
  const formMethods = useForm({
    defaultValues: scrapingTemplateCommentFormInitialValues(scrapingTemplate),
  })

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <Row>
          <TextArea name="comment" label="Comment" autoSize />
        </Row>
        <Row type="flex" justify="end">
          <Button onClick={closeModal} margin="small small no no">
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!hasTemplateAdminPermission}
            loading={isSettingScrapingTemplateComment}
            margin="small no no no"
          >
            Save
          </Button>
        </Row>
        <HiddenInputs names={['id']} />
      </form>
    </FormProvider>
  )
}

ScrapingTemplateCommentForm.propTypes = {
  scrapingTemplate: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  isSettingScrapingTemplateComment: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ScrapingTemplateCommentForm
